"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIALS = void 0;
const materials_json_1 = __importDefault(require("../generator/materials.json"));
exports.MATERIALS = materials_json_1.default;
